<div class="button-icon-wrapper">
    <h-svg-icon
        [name]="iconName()"
        [height]="iconSize()[0]"
        [width]="iconSize()[1]"
        [fill]="iconDrawing() === DRAWING.FILL ? 'currentColor' : 'none'"
        [stroke]="iconDrawing() === DRAWING.STROKE ? 'currentColor' : 'none'" />
</div>
